export enum GenderEnum {
    NonDeclared = 0,
    NonDeclaredDescription = 'Non-Declared',
    Male = 1,
    MaleDescription = 'Male',
    Female = 2,
    FemaleDescription = 'Female',
}
